import { SelectedMetadataFields } from '@modules/ManageUnifiedFields/types';
import { SelectMetadataDataType } from '@modules/common/components/SelectMetadataDataType';
import { UnifiedFieldIcon } from '@modules/common/components/UnifiedFieldIcon';
import {
  Box,
  Divider,
  FormLabel,
  OutlinedInput,
  Stack,
  Typography,
} from '@mui/material';
import { MetadataDataType } from 'generated/graphql';
import { SelectMetadataFieldAutoComplete } from '../SelectMetadataFieldAutoComplete';

interface EditUnifiedFieldFormProps {
  name: string;
  description: string;
  type: MetadataDataType;
  setMetadataName: (name: string) => void;
  setMetadataDescription: (description: string) => void;
  setReferencedKeys: (selectedValues: string[]) => void;
  setMetadataType: (type: MetadataDataType) => void;
  selectedMetadataValues?: SelectedMetadataFields;
}

export const EditUnifiedFieldForm = ({
  name,
  description,
  type,
  selectedMetadataValues,
  setMetadataName,
  setMetadataDescription,
  setReferencedKeys,
  setMetadataType,
}: EditUnifiedFieldFormProps) => {
  return (
    <Box
      component="form"
      noValidate
      autoComplete="off"
      sx={{
        p: 2,
      }}
      width="100%"
    >
      <Stack direction="row" spacing={2}>
        <Box width="60%">
          <FormLabel required component="legend">
            Field Name
          </FormLabel>
          <OutlinedInput
            required
            placeholder="Enter a name for this Unified Field"
            fullWidth
            size="medium"
            defaultValue={name}
            onChange={(e) => setMetadataName(e.target.value)}
          />
        </Box>
        <Box flex={1}>
          <FormLabel required component="legend">
            Field Type
          </FormLabel>
          <SelectMetadataDataType value={type} onChange={setMetadataType} />
        </Box>
      </Stack>

      <FormLabel required component="legend" sx={{ mt: 2 }}>
        Field Description
      </FormLabel>
      <OutlinedInput
        required
        placeholder="Enter a description for this Unified Field"
        fullWidth
        size="medium"
        defaultValue={description}
        onChange={(e) => setMetadataDescription(e.target.value)}
      />

      <Divider variant="fullWidth" sx={{ my: 3 }} />
      <Stack direction="row" spacing={1} my={1}>
        <UnifiedFieldIcon />
        <Typography variant="subtitle2" color="text.secondary">
          Unified metadata fields across integrations
        </Typography>
      </Stack>
      <SelectMetadataFieldAutoComplete
        value={selectedMetadataValues}
        setReferencedKeys={setReferencedKeys}
        metadataType={type}
      />
    </Box>
  );
};
